export default {
    path: '/manufacture',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'industry',
    component: () => import('./index')
  };